import { GlossaryItem } from '../types';

export const carcassonneGlossary: GlossaryItem[] = [
  {
    "id": "aktywny-gracz",
    "term": "Aktywny gracz",
    "definition": "Gracz, którego trwa tura.",
    "aliases": [
      "aktywny"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "obszar",
    "term": "Obszar",
    "definition": "Połączona droga, miasto, klasztor lub pole.",
    "aliases": [
      "feature"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "droga",
    "term": "Droga",
    "definition": "Ścieżka łącząca zakończenia; punktuje 1/kafelek.",
    "aliases": [
      "road"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "miasto",
    "term": "Miasto",
    "definition": "Zamknięty obszar murów; 2+2 herb / 1+1 na końcu.",
    "aliases": [
      "city"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "herb",
    "term": "Herb",
    "definition": "Symbol w mieście dodający punkty.",
    "aliases": [
      "tarcza",
      "coat"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "klasztor",
    "term": "Klasztor",
    "definition": "Punktuje 9 gdy otoczony 8 kafelkami.",
    "aliases": [
      "monastery"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "ogrod",
    "term": "Ogród",
    "definition": "Miejsce tylko dla opata; punktuje jak klasztor.",
    "aliases": [
      "garden"
    ],
    "requiredModuleIds": [
      "abbot"
    ]
  },
  {
    "id": "pole",
    "term": "Pole",
    "definition": "Zielony obszar; 3 pkt/ukończone miasto na końcu.",
    "aliases": [
      "laka",
      "farma"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "podroznik",
    "term": "Podróżnik",
    "definition": "Meeple na drodze.",
    "aliases": [
      "zbojca",
      "traveler"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "rycerz",
    "term": "Rycerz",
    "definition": "Meeple w mieście.",
    "aliases": [
      "knight"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "mnich",
    "term": "Mnich",
    "definition": "Meeple w klasztorze.",
    "aliases": [
      "zakonnik"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "chlop",
    "term": "Chłop",
    "definition": "Leżący meeple na polu.",
    "aliases": [
      "farmer"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "opat",
    "term": "Opat",
    "definition": "Figura na klasztor/ogród z wcześniejszym wycofaniem.",
    "aliases": [
      "abbot"
    ],
    "requiredModuleIds": [
      "abbot"
    ],
    "figureRuleId": "fig-abbot"
  },
  {
    "id": "meeple",
    "term": "Meeple",
    "definition": "Podstawowa figura gracza, siła 1.",
    "aliases": [
      "pionek",
      "poddany",
      "ludzik"
    ],
    "requiredModuleIds": [
      "base"
    ],
    "figureRuleId": "fig-normal-meeple"
  },
  {
    "id": "duzy-meeple",
    "term": "Duży meeple",
    "definition": "Figura siły 2 z Karczem i Katedr.",
    "aliases": [
      "large meeple"
    ],
    "requiredModuleIds": [
      "major-01-inns-cathedrals"
    ],
    "figureRuleId": "fig-large-meeple"
  },
  {
    "id": "sila",
    "term": "Siła",
    "definition": "Wartość do ustalania większości.",
    "aliases": [
      "majority strength"
    ],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "wiekszosc",
    "term": "Większość",
    "definition": "Największa łączna siła na obszarze.",
    "aliases": [],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "remis",
    "term": "Remis",
    "definition": "Równa najwyższa siła na obszarze — pełne punkty dla każdego remisującego. Równy najwyższy wynik końcowy — wspólne zwycięstwo.",
    "aliases": [],
    "requiredModuleIds": [
      "base"
    ]
  },
  {
    "id": "rzeka",
    "term": "Rzeka",
    "definition": "Sekwencja startowa zamiast kafelka startowego.",
    "aliases": [
      "river"
    ],
    "requiredModuleIds": [
      "river"
    ]
  },
  {
    "id": "zrodlo",
    "term": "Źródło",
    "definition": "Pierwszy kafelek Rzeki.",
    "aliases": [],
    "requiredModuleIds": [
      "river"
    ]
  },
  {
    "id": "jezioro",
    "term": "Jezioro",
    "definition": "Ostatni kafelek Rzeki.",
    "aliases": [],
    "requiredModuleIds": [
      "river"
    ]
  },
  {
    "id": "karczma",
    "term": "Karczma",
    "definition": "Premia drogi 2/kafelek gdy ukończona.",
    "aliases": [
      "gospoda",
      "inn"
    ],
    "requiredModuleIds": [
      "major-01-inns-cathedrals"
    ]
  },
  {
    "id": "katedra",
    "term": "Katedra",
    "definition": "Premia miasta 3/kafelek+herb.",
    "aliases": [
      "cathedral"
    ],
    "requiredModuleIds": [
      "major-01-inns-cathedrals"
    ]
  },
  {
    "id": "towar",
    "term": "Towar",
    "definition": "Żeton z ukończonego miasta; 10 za większość na końcu.",
    "aliases": [
      "goods"
    ],
    "requiredModuleIds": [
      "major-02-traders-builders"
    ]
  },
  {
    "id": "budowniczy",
    "term": "Budowniczy",
    "definition": "Figura siły 0 dająca dodatkową turę.",
    "aliases": [
      "builder"
    ],
    "requiredModuleIds": [
      "major-02-traders-builders"
    ],
    "figureRuleId": "fig-builder"
  },
  {
    "id": "swinia",
    "term": "Świnia",
    "definition": "Figura C3.1 punktująca po mieście z herbem.",
    "aliases": [
      "pig",
      "prosiak"
    ],
    "requiredModuleIds": [
      "major-02-traders-builders"
    ],
    "figureRuleId": "fig-pig"
  },
  {
    "id": "smok",
    "term": "Smok",
    "definition": "Neutralna figura — 2 proste długie ruchy.",
    "aliases": [
      "dragon"
    ],
    "requiredModuleIds": [
      "major-03-dragon-fairy"
    ],
    "figureRuleId": "fig-dragon"
  },
  {
    "id": "wrozka",
    "term": "Wróżka",
    "definition": "Chroni meepla i daje +3.",
    "aliases": [
      "fairy"
    ],
    "requiredModuleIds": [
      "major-03-dragon-fairy"
    ],
    "figureRuleId": "fig-fairy"
  },
  {
    "id": "portal",
    "term": "Magiczny portal",
    "definition": "Pozwala stawiać meepla poza nowym kafelkiem.",
    "aliases": [],
    "requiredModuleIds": [
      "major-03-dragon-fairy"
    ]
  },
  {
    "id": "wieza",
    "term": "Wieża",
    "definition": "Budowla z piętrami i zasięgiem.",
    "aliases": [
      "tower"
    ],
    "requiredModuleIds": [
      "major-04-towers-thieves"
    ]
  },
  {
    "id": "straznik",
    "term": "Strażnik",
    "definition": "Meeple na wieży; nie porywa innych.",
    "aliases": [
      "watchman"
    ],
    "requiredModuleIds": [
      "major-04-towers-thieves"
    ],
    "figureRuleId": "fig-tower-guard"
  },
  {
    "id": "zlodziej",
    "term": "Symbol złodzieja",
    "definition": "Rozbudowa wież i punktacja strażników lub kradzież kafelka.",
    "aliases": [
      "thief"
    ],
    "requiredModuleIds": [
      "major-04-towers-thieves"
    ]
  },
  {
    "id": "ratusz",
    "term": "Ratusz",
    "definition": "Specjalny kafelek zawsze pasujący.",
    "aliases": [
      "town hall"
    ],
    "requiredModuleIds": [
      "major-05-messengers-mayors"
    ]
  },
  {
    "id": "burmistrz",
    "term": "Burmistrz",
    "definition": "Figura w mieście siły 0 z favor.",
    "aliases": [
      "mayor"
    ],
    "requiredModuleIds": [
      "major-05-messengers-mayors"
    ],
    "figureRuleId": "fig-mayor"
  },
  {
    "id": "kurier",
    "term": "Kurier",
    "definition": "Figura na drodze mogąca się przenieść po scoringu.",
    "aliases": [
      "poslaniec",
      "messenger"
    ],
    "requiredModuleIds": [
      "major-05-messengers-mayors"
    ],
    "figureRuleId": "fig-messenger-c31"
  },
  {
    "id": "strach",
    "term": "Strach na wróble",
    "definition": "Figura na polu.",
    "aliases": [
      "scarecrow"
    ],
    "requiredModuleIds": [
      "major-05-messengers-mayors"
    ],
    "figureRuleId": "fig-scarecrow"
  },
  {
    "id": "turniej",
    "term": "Turniej",
    "definition": "Rozstrzygnięcie nominacji i nagród.",
    "aliases": [
      "joust"
    ],
    "requiredModuleIds": [
      "major-06-jousts-crests"
    ]
  },
  {
    "id": "godlo",
    "term": "Godło",
    "definition": "Znacznik nominacji/nagrody.",
    "aliases": [
      "crest",
      "emblem"
    ],
    "requiredModuleIds": [
      "major-06-jousts-crests"
    ]
  },
  {
    "id": "korona",
    "term": "Korona",
    "definition": "Wskaźnik kategorii turnieju.",
    "aliases": [],
    "requiredModuleIds": [
      "major-06-jousts-crests"
    ]
  },
  {
    "id": "twierdza",
    "term": "Twierdza",
    "definition": "Duży kafelek startowy obrony.",
    "aliases": [
      "fortress"
    ],
    "requiredModuleIds": [
      "major-07-siege-defense"
    ]
  },
  {
    "id": "katapulta",
    "term": "Katapulta",
    "definition": "Znacznik ataku na stanowisku.",
    "aliases": [],
    "requiredModuleIds": [
      "major-07-siege-defense"
    ]
  },
  {
    "id": "most",
    "term": "Most",
    "definition": "Budynek łączący drogę; 3 w trakcie / 1 na końcu.",
    "aliases": [
      "bridge"
    ],
    "requiredModuleIds": [
      "major-08-castles-bridges"
    ]
  },
  {
    "id": "zamek",
    "term": "Zamek",
    "definition": "Budynek na 2-segmentowym mieście z damą.",
    "aliases": [
      "castle"
    ],
    "requiredModuleIds": [
      "major-08-castles-bridges"
    ]
  },
  {
    "id": "stodola",
    "term": "Stodoła",
    "definition": "Budynek na 4 narożnikach pola.",
    "aliases": [
      "barn"
    ],
    "requiredModuleIds": [
      "major-08-castles-bridges"
    ]
  },
  {
    "id": "pasterz",
    "term": "Pasterz",
    "definition": "Figura stada na polu.",
    "aliases": [
      "shepherd"
    ],
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ],
    "figureRuleId": "fig-shepherd"
  },
  {
    "id": "stado",
    "term": "Stado",
    "definition": "Żetony owiec przy pasterzach.",
    "aliases": [
      "flock"
    ],
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ]
  },
  {
    "id": "wilk",
    "term": "Wilk",
    "definition": "Czyści stado i pasterzy bez punktów.",
    "aliases": [
      "wolf"
    ],
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ]
  },
  {
    "id": "gesi",
    "term": "Gęsi",
    "definition": "Premia +1/kafelek dla aktywnego przy wypasie.",
    "aliases": [
      "geese"
    ],
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ]
  },
  {
    "id": "winnica",
    "term": "Winnica",
    "definition": "+3 przy punktowaniu klasztoru/ogrodu.",
    "aliases": [
      "vineyard"
    ],
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ]
  },
  {
    "id": "cyrk",
    "term": "Plac cyrkowy",
    "definition": "Miejsce żetonu występu i namiotu.",
    "aliases": [
      "circus"
    ],
    "requiredModuleIds": [
      "major-10-circus-artists"
    ]
  },
  {
    "id": "akrobata",
    "term": "Akrobata",
    "definition": "Meeple w piramidzie do 3 figur.",
    "aliases": [
      "acrobat"
    ],
    "requiredModuleIds": [
      "major-10-circus-artists"
    ],
    "figureRuleId": "fig-acrobat"
  },
  {
    "id": "dyrektorka",
    "term": "Dyrektorka cyrku",
    "definition": "Figura z premią za place w sąsiedztwie.",
    "aliases": [
      "ringmistress"
    ],
    "requiredModuleIds": [
      "major-10-circus-artists"
    ],
    "figureRuleId": "fig-ringmistress"
  },
  {
    "id": "namiot",
    "term": "Wielki namiot",
    "definition": "Zakrywa aktualny żeton występu.",
    "aliases": [
      "big top"
    ],
    "requiredModuleIds": [
      "major-10-circus-artists"
    ]
  },
  {
    id: 'mgla',
    term: 'Mgła',
    definition:
      'Obszar kafelków z mglistymi krawędziami. W kooperacji ignorowana przy dopasowaniu; zamknięcie zdejmuje duchy z obszaru.',
    aliases: ['mist', 'fog', 'mgla nad carcassonne'],
    requiredModuleIds: ['mists-over-carcassonne'],
    sectionId: 'mists-fog-ghosts',
  },
  {
    id: 'duch',
    term: 'Duch',
    definition:
      'Figurka zagrożenia w Mgły. Wystawiana wg symboli; brak w zapasie przy wystawieniu = przegrana kooperacji.',
    aliases: ['ghost', 'duchy'],
    requiredModuleIds: ['mists-over-carcassonne'],
    sectionId: 'mists-fog-ghosts',
    figureRuleId: 'fig-ghost',
  },
  {
    id: 'cmentarz-mists',
    term: 'Cmentarz',
    definition:
      'Kafelek specjalny od poziomu 2. Zamyka się na 4 bokach (nawiedzony na 8). Pochowanie meepla i zdejmowanie duchów przy zamknięciu.',
    aliases: ['cemetery', 'nawiedzony cmentarz'],
    requiredModuleIds: ['mists-over-carcassonne'],
    sectionId: 'mists-level-2',
  },
  {
    id: 'pies-mists',
    term: 'Pies (Rufus / Ronja)',
    definition:
      'Od poziomu 3: psy pomagają usuwać duchy według reguł poziomu. Nie mylić z innymi figurami C3.',
    aliases: ['rufus', 'ronja', 'hound', 'dog'],
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    sectionId: 'mists-level-3',
    figureRuleId: 'fig-hound',
  },
  {
    id: 'zamek-mists',
    term: 'Zamek (Mgła)',
    definition:
      'Od poziomu 2: punktuje po otoczeniu (2 pkt za otaczający kafelek z mgłą). Meeple można postawić na zamku.',
    aliases: ['castle mist', 'zamek mgly'],
    requiredModuleIds: ['mists-over-carcassonne'],
    sectionId: 'mists-level-2',
  },
];
